export default { 
    'Home.CreateBtn':'Create An Oration',
    'Home.Menu1':'WorkSpace',
    'Home.Logout':'Logout',
    'Home.Logout.Model.title': 'Tips',
    'Home.Logout.Model.text':'Logout',
    'Home.Logout.Model.content':'Do you want to log out?',
    'Home.Logout.Model.okText':'OK',
    'Home.Logout.Model.cancelText':'Cancle',
}